import { render, staticRenderFns } from "./PayeeDetails.vue?vue&type=template&id=57145a53"
import script from "./PayeeDetails.vue?vue&type=script&lang=js"
export * from "./PayeeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports